<p><i class="fas fa-exclamation-circle"></i><span>{{ textError }}</span></p>
